import { css } from '@emotion/react';

export const headerBarItemClass = css`
  flex: 50%;
  display: flex;
  align-items: center;
`;
